import React from "react";

function BinanceSmartChain() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>Why Choose Binance Smart Chain for Your Project?</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  Binance Smart Chain (BSC) has emerged as a powerful blockchain
                  platform, known for its low fees, fast block times, and robust
                  smart contract capabilities. It enables developers to create
                  scalable and efficient decentralized applications (DApps) and
                  DeFi solutions without compromising on performance.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default BinanceSmartChain;
